import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import AllPortals from "@/components/GetPortals/PortalsComponent.vue"
import Column from "@/components/Column/Column.vue"
import { get_token, get_user_details } from "@/router";
import axios from "axios";
import draggable from 'vuedraggable';

export default {
  name: 'Board',
  components: {
    draggable,
    AllPortals,
    Column,
    HomeNavBar

  },
  data() {
    return ({
      buckets: [],
      isAddingBucket: false,
      newBucketTitle: '',
      members: [],
      board_loading:true,
      filterDropdownOpen: false,
      availableStatuses: [],
      availablePriorities: [],
      filters: {
        search: "",
        users: [],
        statuses: [],
        dateFrom: "",
        dateTo: "",
      },
      showAllMembers: false,
      showAllStatuses: false,
      portals_open: true,
      portal_admin: false,
      user_details: get_user_details() || { user_role: '' }
});
  },

  computed: {
    can_manage_task_statuses() {
      return this.user_details?.user_role === 'admin' || this.portal_admin;
    },
    activeFilterCount() {
      return this.filters.users.length
        + this.filters.statuses.length
        + (this.filters.search ? 1 : 0)
        + (this.filters.dateFrom ? 1 : 0)
        + (this.filters.dateTo ? 1 : 0);
    },
    filteredTaskCount() {
      return this.buckets.reduce((total, bucket) => total + (bucket?.tasks?.length || 0), 0);
    },
  },
  watch:{
    'filters.users': {
      deep: true,
      handler() {
        this.fetch_board_columns();
      }
    },
    'filters.statuses': {
      deep: true,
      handler() {
        this.fetch_board_columns();
      }
    },
    'filters.dateFrom'() {
      this.fetch_board_columns();
    },
    'filters.dateTo'() {
      this.fetch_board_columns();
    },
    'filters.search'() {
      this.fetch_board_columns();
    }
  },
created() {
  this.fetch_Portal_admin();
  this.fetch_task_statuses();
  this.fetch_priority_statuses();
  this.fetch_board_columns().then(() => {
    this.fetchPortalMembers();
  });
  
},
  methods: {

    format_label(text) {
      if (!text) return '';
      return text
        .trim()
        .split(/[\s_-]+/)
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    },
    get_member_initials(member) {
      const name = String(member?.full_name || member?.username || member?.name || "").trim();
      if (!name) return "?";

      return name
        .split(/\s+/)
        .map((part) => part.charAt(0))
        .join("")
        .toUpperCase()
        .slice(0, 2);
    },
    chip_palette_class(seed, prefix = 'task-chip-tone') {
      const value = String(seed || '').trim();
      const hash = value.split('').reduce((total, char) => total + char.charCodeAt(0), 0);
      return `${prefix}-${hash % 8}`;
    },
    status_chip_class(status) {
      return this.chip_palette_class(status?.id || status?.task_name || status?.name || status?.label);
    },
    getToken() {
      return get_token();
    },
    get_user_id() {
      return localStorage.getItem('user_id') || '';
    },
    fetch_Portal_admin() {
      const user_id = Number(this.get_user_id());

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_plartform_admin_api/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          portal_id: this.$route.params.portal_id,
          user_id
        }),
        success: (response) => {
          if (response.status === 'success') {
            const admins = response?.portal_admin_detalails || [];
            this.portal_admin = admins.some((admin) => Number(admin?.user?.id) === user_id);
            return;
          }
          this.portal_admin = false;
        },
        error: () => {
          this.portal_admin = false;
        }
      });
    },
    goBack() {
      this.$router.back();
    },

    toggleUserFilter(userId) {
      const index = this.filters.users.indexOf(userId);
      if (index === -1) {
        // Not in the array yet, so add it
        this.filters.users.push(userId);
      } else {
        // Already in the array, so remove it (un-click)
        this.filters.users.splice(index, 1);
      }
    },

    toggleStatusFilter(statusId) {
      const index = this.filters.statuses.indexOf(statusId);
      if (index === -1) {
        this.filters.statuses.push(statusId);
      } else {
        this.filters.statuses.splice(index, 1);
      }
    },
clearAllFilters() {
  this.filters = { search: "", users: [], statuses: [], dateFrom: "", dateTo: "" };
},


    fetch_task_statuses() {
     $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_task_statuses/`,
          method: 'POST',
          headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
          },
          success: (response) => {
          var status = response.status
          if (status == "success") {
              this.availableStatuses = response.data;
          }

          },

      });

    },
  fetch_priority_statuses() {
    $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_priority_statuses/`,
        method: 'POST',
        headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
        },
        success: (response) => {
            var status = response.status
            if (status == "success") {
                this.availablePriorities = response.data
            }
        }
    });
  },

  on_column_drag_change(evt) {
  if (!evt || !evt.moved) return;

  const movedColumn = this.buckets[evt.moved.newIndex];
  if (!movedColumn) return;

  const board_id = this.$route.params.board_id; // ✅ manually reference board id
  const column_id = movedColumn.id;
  const new_position = evt.moved.newIndex + 1;

  this.moveColumn(board_id, column_id, new_position);
},


moveColumn(board_id, column_id, new_position) {
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/move_board_column_position/`,
    method: "POST",
    data: JSON.stringify({
      board_id: board_id,
      column_id: column_id,
      new_position: new_position,
    }),
    headers: {
      Authorization: `Token ${this.getToken()}`,
      "Content-Type": "application/json",
    },
  });
},
    async fetch_board_columns() {
      this.board_loading = true;

      const payload = {
        board_id: this.$route.params.board_id,
        search: this.filters.search,
        assignee_ids: this.filters.users,
        statuses: this.filters.statuses,
        due_after: this.filters.dateFrom,    // <-- Updated to target due_date
        due_before: this.filters.dateTo      // <-- Updated to target due_date
      };

      const headersConfig = {
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
      };

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_board_columns/`,
          payload,
          headersConfig
        );

        if (response.data.status === "success") {
  this.buckets = response.data.data.map(c => ({
            ...c,
            tasks: c.tasks || [],
            tasks_pagination: c.tasks_pagination || { current_page: 1, total_pages: 1, total_tasks: c.tasks?.length || 0 }
          }));
}

        return response;
      } catch (error) {
        console.error("Error fetching board columns:", error);
        throw error;
      } finally {
        this.board_loading = false;
      }
    },
    add_new_column() {
      this.isAddingBucket = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_column/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({ board_id: this.$route.params.board_id, name: this.newBucketTitle }),
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.buckets.push(response.data)
            this.newBucketTitle = '';
            this.isAddingBucket = false;
          }

        },

      });
    },
    startAddingBucket() {
      this.isAddingBucket = true;
      this.newBucketTitle = '';
      this.$nextTick(() => {
        this.$refs.newBucketInput?.focus();
      });
    },
    deleteBucket(index) {
      this.buckets.splice(index, 1);
    },
    fetchPortalMembers() {
      this.members = [];

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
        method: "GET",
        data: { portal_id: this.$route.params.portal_id },
        headers: {
          "Authorization": `Token ${this.getToken()}`,
          "Content-Type": "application/json"
        },
        success: (response) => {
          if (response.status === "success") {
            this.members = response.data.members;
          }
        },
        error: (xhr) => {
          console.error("Error fetching portal members:", xhr);
        }
      });
    },
  }
};
